import { Output } from 'tsickle/build/definitions/tsickle';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { FrontService } from './front.service';
import { Menu } from '../models/menu.model';
import { Subscription } from 'rxjs/Subscription';
import { MyDesktopService } from '../services/mydesktop.service';
import { ClientService } from '../services/client.service';
import { Client } from '../models/client.model';
import { UserService } from '../services/user.service';
import { User } from '../models/user.model';
import { PasteService } from '../services/paste.service';
import { ChangelogService } from '../services/changelogs.service';

import { FormGroup, FormControl, Validators } from '@angular/forms';

import { Auth } from '../models/auth.model';

declare var swal: any;

@Component({
  selector: 'app-front',
  templateUrl: './front.component.html',
  styleUrls: ['./front.component.css']
})
export class FrontComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  subscriptionClient: Subscription;
  subscriptionUser: Subscription;
  subscriptionChangelogs: Subscription;
  subscriptionSwitchOffice: Subscription;

  menus: Menu[];

  public paste_alert = false;
  new_notification = false;
  headline = '';
  is_changelog_button_hidden = false;

  authUser: Auth;
  isMultipleOffice = false;
  multipleOffice = [];

  switchOfficeForm: FormGroup;

  currentSlide = 1;

  instructions = {
    'step1': 'Drag over the new "Article" Elements',
    'step2': 'Click the main image and select the "Article Search" button',
    'step3': 'Search through thousands of articles',
    'step4': 'Once added to your article library, simply click the insert button to populate your element'
  };

  isPartica = false;

  @ViewChild('sidebarWrapper') sidebar: ElementRef;
  @ViewChild('contentWrapper') content: ElementRef;

  constructor(private frontService: FrontService,
              private mydesktopService: MyDesktopService,
              private clientService: ClientService,
              private route: ActivatedRoute,
              private userService: UserService,
              private router: Router,
              private pasteService: PasteService,
              private changelogService: ChangelogService) { }

  ngOnInit() {
    if ( localStorage.getItem('currentVersion') !== '1.0.0') {
      return window.location.href = '/login';
    }

    if ( localStorage.getItem('md3Auth_provider') === null ) {
      return window.location.href = '/login';
    }

    this.authUser = this.frontService.authService.auth;
    if ( this.authUser.multiple.length > 1 ) {
      this.isMultipleOffice = true;
      this.multipleOffice = this.authUser.multiple.map(
        (obj) => {
          return {id: obj.groupid, name: obj.office};
        }
      );
    }

    this.subscription = this.frontService.menuChanged.subscribe(
      (menus: Menu[]) => {
        if (this.frontService.fullPageContent) {
          this.sidebar.nativeElement.className = 'hidden height-100';
          this.content.nativeElement.className = 'full-page height-100';
          this.frontService.fullPageContent = false;
        } else {
            this.sidebar.nativeElement.className = 'height-100';
            this.content.nativeElement.className = 'height-100';
        }
      }
    );

    this.userService.httpGetUserByAgentID(this.frontService.authService.auth.agentid);

    this.subscriptionUser = this.userService.userChanged.subscribe(
      (User: User) => {
        if (typeof User !== 'undefined') {
          if (User.new_notification == '1') {
            this.changelogService.httpGetLast({
              provider: ['all', this.authUser.provider],
              group_id: this.authUser.client.group_id
            });
          }

          if (User.paste_alert == 1) {
            this.pasteService.paste_alert = true;
          }
        }
      }
    );

    this.subscriptionClient = this.clientService.clientChanged.subscribe(
      (client: Client) => {
        if (typeof client.ID !== 'undefined') {
          this.frontService.authService.updateAuthCookieField('client', JSON.stringify(client));

          if (client.is_account_active !== 1 || client.group.is_account_active !== 1) {
            swal(
              'Account has been blocked.',
              'Kindly contact MyDesign Support Team.',
              'error'
            );

            this.frontService.authService.deleteAuthCookie();
            this.router.navigate(['/login']);
          }
        }
      }
    );

    this.changelogService.onGetLast
    .subscribe(
      (changelog: any) => {
        if ( typeof changelog !== 'undefined' && changelog.status === 'success' ) {
          this.new_notification = true;
          this.headline = changelog.data.headline;

          if ( changelog.data.is_button_hidden === 1 ) {
            this.is_changelog_button_hidden = true;
          }
        }
      }
    );

    this.clientService.httpGetClient(+this.frontService.authService.auth._ID);

    this.subscriptionSwitchOffice = this.mydesktopService.myDesktopAuthSwitch.subscribe(
      (authSwitch: any) => {
        if (typeof authSwitch !== 'undefined' && authSwitch
          && authSwitch.status === 'success'
          && typeof authSwitch.data.token !== 'undefined' ) {
          this.mydesktopService.authService.setAuthSwitch(authSwitch.data);

          location.reload();
        } else if (typeof authSwitch !== 'undefined' && authSwitch && authSwitch.status === 'blocked' ) {
          swal(
            'Account has been blocked.',
            'Kindly contact MyDesign Support Team.',
            'error'
          );
        }
      }
    );

    this.userService.userOperation.subscribe(
    (user: any) => {
        if ( typeof user !== 'undefined' && typeof user.ID !== 'undefined' ) {
          if ( this.isPartica ) {
            this.router.navigateByUrl('/content/marketplace');
          }
        }
      }
    );

    this.menus = [];
    this.frontService.loadMenu(this.menus);

    this.initForm();
  }

  private initForm() {
    this.switchOfficeForm = new FormGroup({
      'office_id': new FormControl('', Validators.required)
    });
  }

  onViewNotification() {
    const user = {
      new_notification: 0
    };

    this.userService.httpPutUserByAgentID(this.frontService.authService.auth.agentid, user);
    jQuery('.notification_area').css('display', 'none');

    window.open('/help/changelogs/' + this.frontService.authService.auth.client.group_id, '_blank');
  }

  onNotificationClose() {
    const user = {
      new_notification: 0
    };

    this.userService.httpPutUserByAgentID(this.frontService.authService.auth.agentid, user);
    jQuery('.notification_area').css('display', 'none');
  }

  onSubmitSwitch () {
    if (this.switchOfficeForm.valid) {
      const switchValues = this.switchOfficeForm.value;

      const index = this.authUser.multiple.findIndex(c => c.groupid === +switchValues['office_id']);

      const token = this.authUser.multiple[ index ].token;

      delete switchValues['office_id'];

      switchValues['office'] = this.authUser.multiple[ index ].office;
      switchValues['pftoken'] = this.authUser.multiple[ index ].pftoken;
      switchValues['brandid'] = this.authUser.multiple[ index ].brandid;
      switchValues['agentid'] = this.authUser.multiple[ index ].agentid;
      switchValues['groupid'] = this.authUser.multiple[ index ].groupid;

      if (token && typeof token !== 'undefined') {
        swal({
          title: 'Switching office account to ' + switchValues['office'],
          onOpen: function () {
            swal.showLoading ();
          }
        });
        this.mydesktopService.httpPostAuthSwitch(switchValues, token);
      }
    }
  }

  onDisablePopup() {
    if ( this.checkIfDontShowChecked() ) {
      localStorage.setItem('tmp_partica_popup_disabled', 'yes');
      const user = {
        partica_popup: 1
      };
      this.userService.httpPutUserByAgentID(this.frontService.authService.auth.agentid, user);
    }
  }

  onGoToMarketplace() {
    $('#articleModal').modal('hide');
    if ( this.checkIfDontShowChecked() ) {
      this.isPartica = true;
      this.onDisablePopup();
    } else {
      this.router.navigateByUrl('/content/marketplace');
    }
  }

  checkIfDontShowChecked() {
    return $('#showCheckBox').is(':checked');
  }

  slider(type) {
    if ( type === 'prev' ) {
      if ( this.currentSlide === 1 ) {
        return false;
      } else {
        this.currentSlide -= 1;
      }
    } else {
      if ( this.currentSlide === 4 ) {
        return false;
      } else {
        this.currentSlide += 1;
      }
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptionClient.unsubscribe();
    this.subscriptionUser.unsubscribe();
    this.subscriptionSwitchOffice.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/front/front.component.ts